// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2LxpI","signatureButtonsRight":"ModalSign_signatureButtonsRight__2jZXo"};